import { Box, Typography } from '@mui/material';
import { colors } from '../../../styles/fontStyles';
import { ABOVE_RANGE } from '../../../constants/report';
import { useThemeContext } from '../../../contexts/BaseThemeContextProvider';

export const ResultTimelineCompoundTooltip = ({ compoundData }: any) => {
  const { theme } = useThemeContext();
  const isCompoundAboveRange = compoundData.compoundLabel.toLowerCase().trim().includes(ABOVE_RANGE.toLowerCase());

  const isCompValueNumeric =
    !isNaN(parseFloat(compoundData.compoundDisplayValue)) && isFinite(compoundData.compoundDisplayValue);

  return (
    <Box
      sx={{
        position: 'relative',
        background: theme.custom.report.timeline.compoundInNHANESTimelineChart.tooltip.backgroundColor,
        borderRadius: '8px',
        border: `2px solid ${theme.custom.report.timeline.compoundInNHANESTimelineChart.tooltip.borderColor}`,
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}
    >
      {/* Content */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexBasis: { xs: '45%', sm: 'auto' },
          }}
        >
          <Typography
            sx={{
              fontSize: isCompValueNumeric ? '28px' : '16px',
              fontWeight: 400,
              lineHeight: '36px',
              color: theme.custom.report.timeline.compoundInNHANESTimelineChart.tooltip.compoundDisplayValue.color,
              marginRight: '4px',
            }}
          >
            {compoundData.compoundDisplayValue ?? '---'}
          </Typography>
          {isCompValueNumeric && (
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 400,
                color: theme.custom.report.timeline.compoundInNHANESTimelineChart.tooltip.compoundLevel.color,
                lineHeight: '14px',
                marginTop: '-3px',
              }}
            >
              Level <br /> ng/mL
            </Typography>
          )}
        </Box>
        {/* Divider Line */}
        <Box
          sx={{
            width: '2px',
            height: '40px',
            margin: '0 12px',
            backgroundColor: theme.custom.report.timeline.compoundInNHANESTimelineChart.tooltip.dividerLineColor,
            borderRadius: '4px',
          }}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
          }}
        >
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: 400,
              color:
                theme.custom.report.timeline.compoundInNHANESTimelineChart.tooltip.compoundDetectionFrequency.color,
              lineHeight: '12px',
            }}
          >
            {compoundData.detectionFrequency ?? '--'} detection frequency
          </Typography>
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 500,
              color: theme.custom.report.timeline.compoundInNHANESTimelineChart.tooltip.compoundLoq.color,
              lineHeight: '24px',
            }}
          >
            LOQ {compoundData.loq ?? '--'} ng/mL
          </Typography>
        </Box>
      </Box>
      {isCompoundAboveRange && (
        <Box>
          <Typography
            sx={{
              fontSize: '12px',
              fontWeight: 500,
              color: theme.custom.report.timeline.compoundInNHANESTimelineChart.tooltip.compoundAboveRange.color,
              lineHeight: '26px',
            }}
          >
            We are not allowed to display values above our reportable ranges.
          </Typography>
        </Box>
      )}
    </Box>
  );
};
